var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"preloader flex-column justify-content-center align-items-center",attrs:{"id":"preloader_root"}},[_c('img',{staticClass:"animation__wobble",attrs:{"src":require("../assets/img/logotipo-normal_dark.png"),"alt":"Administração DNC"}})])
}]

export { render, staticRenderFns }